import React, { MouseEventHandler } from 'react';
import { Dialog, DialogContent, Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Watch } from 'react-loader-spinner';
import { LoadingButton } from '@mui/lab';

export const Popup: React.FC<{
  title: string;
  open: boolean;
  dialogContent: string;
  serverErrorMessage: string;
  loading: boolean;
  acceptButtonTitle: string;
  handleAcceptOnClick: MouseEventHandler;
  rejectButtonTitle: string;
  handleRejectOnClick: MouseEventHandler;
}> = ({
  title,
  open,
  dialogContent,
  serverErrorMessage,
  loading,
  acceptButtonTitle,
  handleAcceptOnClick,
  rejectButtonTitle,
  handleRejectOnClick,
}): React.ReactElement => {
  return (
    <Dialog
      PaperProps={{
        style: {
          minWidth: 390,
          borderRadius: '8px',
          padding: 48,
          backgroundColor: '#0B0614',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          boxShadow: '-4px 4px 14px rgba(255, 255, 255, 0.25)',
        },
      }}
      open={open}
      keepMounted
      sx={{ background: 'rgba(0, 0, 0, 0.4)' }}>
      <DialogContent>
        <Grid container direction="column" spacing={3}>
          <Grid>
            <Typography variant="h2">{title}</Typography>
          </Grid>
          <Grid>
            <Typography color="#D9D9D9">{dialogContent} </Typography>
          </Grid>
          {serverErrorMessage && (
            <Grid>
              <Typography color="error" textAlign="center">
                {serverErrorMessage}
              </Typography>
            </Grid>
          )}
          <Grid container direction="row" spacing={2}>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}>
              <LoadingButton
                onClick={handleAcceptOnClick}
                loadingIndicator={<Watch color="#F1F1F1" width={30} height={20} />}
                loading={loading}
                variant="outlinedDangerous"
                color="error"
                fullWidth>
                {acceptButtonTitle}
              </LoadingButton>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}>
              <Button
                fullWidth
                variant="outlinedWhite"
                disabled={loading}
                onClick={handleRejectOnClick}>
                {rejectButtonTitle}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Popup;
